import { Box, CircularProgress } from '@mui/material'

export function TableLoading() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100px',
      }}
    >
      <CircularProgress />
    </Box>
  )
}
